"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProductDomain = exports.isMultiDomain = exports.isBundleProduct = exports.hasDomainsInFlow = exports.getActiveBundleId = void 0;
/* eslint-disable no-undefined */
/**
 * Domain utility functions - isolated to avoid import issues
 */

/**
 * Check if a specific product is a domain
 * @param {Object} instance The instance object containing all products
 * @param {string} product The product key to check
 * @returns {boolean} True if the product is a domain
 */
const isProductDomain = (instance, product) => {
  return instance?.[product]?.properties?.productType === 'domain';
};

/**
 * Check if the environment is a multi-domain
 * @param {Object} environment The environment object containing the domains
 * @returns {boolean} True if the environment is a multi-domain
 */
exports.isProductDomain = isProductDomain;
const isMultiDomain = environment => {
  return environment?.domains > 1;
};

/**
 * Check if the current flow contains any domain products
 * @param {Object} instance The instance object containing all products
 * @returns {boolean} True if any product in the instance is a domain
 */
exports.isMultiDomain = isMultiDomain;
const hasDomainsInFlow = instance => {
  if (!instance || typeof instance !== 'object') {
    return false;
  }
  return Object.values(instance).some(item => item?.properties?.productType === 'domain');
};

/**
 * Check if a specific product is a bundle product
 * @param {Object} instance The instance object containing all products
 * @param {string} product The product key to check
 * @returns {boolean} True if the product is a bundle product
 */
exports.hasDomainsInFlow = hasDomainsInFlow;
const isBundleProduct = (instance, product) => {
  return instance?.[product]?.properties?.productType === 'domain-product-bundle';
};

/**
 * Get the active bundle ID from the instance
 * @param {Object} instance The instance object containing all products
 * @returns {string|undefined} The active bundle ID or undefined if no active bundle
 */
exports.isBundleProduct = isBundleProduct;
const getActiveBundleId = instance => {
  if (!instance || typeof instance !== 'object') {
    return undefined;
  }
  return Object.keys(instance).find(key => typeof instance[key].properties?.selection === 'string' && instance[key].properties?.selection !== 'none' && isBundleProduct(instance, key));
};
exports.getActiveBundleId = getActiveBundleId;